import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const SellerWaitingManage = () => {
  const [loading, setLoading] = useState(true);
  const [shopId, setShopId] = useState(0);
  const [curFilter, setCurFilter] = useState('WAITING');
  const [rows, setRows] = useState([]);
  const [listError, setListError] = useState('');

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [people, setPeople] = useState('2');

  const [avg, setAvg] = useState('5');
  const [maxp, setMaxp] = useState('6');
  const [msgHtml, setMsgHtml] = useState('');

  const wsRef = useRef(null);
  const reconnectRef = useRef(null);

  function onlyNum(s) {
    return (s || '').replace(/[^0-9]/g, '');
  }

  async function api(fd) {
    const res = await axios.post('/api/seller/waiting/manage-api', fd, {
      withCredentials: true,
    });
    return res.data;
  }

  async function loadSettings(sid = shopId) {
    const fd = new FormData();
    fd.append('mode', 'get_settings');
    fd.append('shop_id', sid);
    const j = await api(fd);

    if (j.success && j.data) {
      setAvg(String(j.data.avg_minutes_per_team ?? 5));
      setMaxp(String(j.data.max_people ?? 6));
    }
  }

  async function saveSettings() {
    const fd = new FormData();
    fd.append('mode', 'save_settings');
    fd.append('shop_id', shopId);
    fd.append('avg', avg);
    fd.append('maxp', maxp);

    const j = await api(fd);
    setMsgHtml(`<div class="alert alert-${j.success ? 'success' : 'danger'} py-2 mb-0">${j.message || ''}</div>`);
  }

  function rowBadge(status) {
    return {
      WAITING: 'secondary',
      CALLED: 'warning',
      ENTERED: 'success',
      CANCELLED: 'dark',
      NO_SHOW: 'danger',
    }[status] || 'secondary';
  }

  async function loadList(sid = shopId, filter = curFilter) {
    const fd = new FormData();
    fd.append('mode', 'list');
    fd.append('shop_id', sid);
    fd.append('filter', filter);

    const j = await api(fd);

    if (!j.success) {
      setListError(j.message || '조회 실패');
      setRows([]);
      return;
    }

    setListError('');
    setRows(j.rows || []);
  }

  async function setStatus(id, action) {
    const fd = new FormData();
    fd.append('mode', action);
    fd.append('shop_id', shopId);
    fd.append('waiting_id', id);

    const j = await api(fd);
    if (!j.success) alert(j.message || '실패');
    loadList();
  }

  async function quickAdd() {
    const cleanName = name.trim();
    const cleanPhone = onlyNum(phone.trim());
    const peopleNum = parseInt(people, 10);

    if (!cleanName) return alert('이름 입력');
    if (!cleanPhone || cleanPhone.length < 9) return alert('전화번호 확인');
    if (!peopleNum || peopleNum < 1) return alert('인원 확인');

    const fd = new FormData();
    fd.append('mode', 'add');
    fd.append('shop_id', shopId);
    fd.append('name', cleanName);
    fd.append('phone', cleanPhone);
    fd.append('people', String(peopleNum));

    const j = await api(fd);
    if (!j.success) return alert(j.message || '등록 실패');

    setName('');
    setPhone('');
    setPeople('2');
    loadList();
  }

  function connectWS(sid) {
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const ws = new WebSocket(`${proto}://${window.location.host}/ws/?shop_id=${sid}`);

    wsRef.current = ws;

    ws.onopen = () => console.log('WS connected');
    ws.onclose = () => {
      reconnectRef.current = setTimeout(() => connectWS(sid), 1500);
    };
    ws.onerror = () => ws.close();

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        if (msg.type === 'waiting' && Number(msg.shop_id) === Number(sid)) {
          loadList(sid, curFilter);
        }
      } catch (err) {}
    };
  }

  useEffect(() => {
    const init = async () => {
      try {
        const res = await axios.get('/api/seller/waiting/manage-init', {
          withCredentials: true,
        });

        if (!res.data || res.data.ok !== true) {
          alert((res.data && res.data.msg) || '초기화 실패');
          window.location.href = '/seller/manage';
          return;
        }

        const sid = Number(res.data.shop_id || 0);
        setShopId(sid);

        await loadSettings(sid);
        await loadList(sid, 'WAITING');
        connectWS(sid);
      } catch (e) {
        console.error(e);
        alert('초기화 실패');
      } finally {
        setLoading(false);
      }
    };

    init();

    return () => {
      if (reconnectRef.current) clearTimeout(reconnectRef.current);
      if (wsRef.current) wsRef.current.close();
    };
  }, []);

  useEffect(() => {
    if (!loading && shopId > 0) {
      loadList(shopId, curFilter);
    }
  }, [curFilter]);

  if (loading) {
    return <div className="container-fluid py-3">불러오는 중...</div>;
  }

  return (
    <div className="container-fluid py-3">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="m-0">웨이팅 관리</h4>
        <button className="btn btn-outline-secondary btn-sm" onClick={() => loadList()}>
          새로고침
        </button>
      </div>

      <div className="row g-3">
        <div className="col-lg-7">
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="d-flex gap-2 mb-2">
                <button className="btn btn-sm btn-primary" onClick={() => setCurFilter('WAITING')}>대기</button>
                <button className="btn btn-sm btn-warning" onClick={() => setCurFilter('CALLED')}>호출</button>
                <button className="btn btn-sm btn-success" onClick={() => setCurFilter('ENTERED')}>입장</button>
                <button className="btn btn-sm btn-secondary" onClick={() => setCurFilter('ALL')}>전체</button>
              </div>

              {listError ? (
                <div className="text-danger">{listError}</div>
              ) : (
                <>
                  <div className="small text-muted mb-2">
                    필터: {curFilter} · 총 {rows.length}건
                  </div>

                  <div className="table-responsive">
                    <table className="table table-sm align-middle">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>정보</th>
                          <th>상태</th>
                          <th>등록</th>
                          <th>작업</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.length > 0 ? (
                          rows.map((r) => (
                            <tr key={r.id}>
                              <td className="text-nowrap fw-bold">#{r.waiting_number}</td>
                              <td>
                                <div className="fw-semibold">{r.name}</div>
                                <div className="text-muted small">{r.phone} · {r.people}명</div>
                              </td>
                              <td className="text-nowrap">
                                <span className={`badge text-bg-${rowBadge(r.status)}`}>{r.status}</span>
                              </td>
                              <td className="text-nowrap small text-muted">{r.created_at}</td>
                              <td className="text-nowrap">
                                {r.status === 'WAITING' && (
                                  <>
                                    <button className="btn btn-sm btn-warning me-1" onClick={() => setStatus(r.id, 'call')}>
                                      호출
                                    </button>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => setStatus(r.id, 'cancel')}>
                                      취소
                                    </button>
                                  </>
                                )}
                                {r.status === 'CALLED' && (
                                  <>
                                    <button className="btn btn-sm btn-success me-1" onClick={() => setStatus(r.id, 'enter')}>
                                      입장
                                    </button>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => setStatus(r.id, 'noshow')}>
                                      노쇼
                                    </button>
                                  </>
                                )}
                                {r.status !== 'WAITING' && r.status !== 'CALLED' && '-'}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-muted py-4">없음</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="col-lg-5">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="mb-3">빠른 등록(직원)</h5>

              <div className="mb-2">
                <label className="form-label">이름</label>
                <input className="form-control" maxLength="50" value={name} onChange={(e) => setName(e.target.value)} />
              </div>

              <div className="mb-2">
                <label className="form-label">전화번호</label>
                <input
                  className="form-control"
                  maxLength="20"
                  placeholder="01012345678"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">인원</label>
                <input
                  type="number"
                  className="form-control"
                  value={people}
                  min="1"
                  max="20"
                  onChange={(e) => setPeople(e.target.value)}
                />
              </div>

              <button className="btn btn-primary w-100" onClick={quickAdd}>등록</button>

              <hr className="my-4" />

              <h5 className="mb-2">설정</h5>

              <div className="row g-2">
                <div className="col-6">
                  <label className="form-label">팀당 평균(분)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={avg}
                    min="1"
                    max="60"
                    onChange={(e) => setAvg(e.target.value)}
                  />
                </div>
                <div className="col-6">
                  <label className="form-label">최대 인원</label>
                  <input
                    type="number"
                    className="form-control"
                    value={maxp}
                    min="1"
                    max="30"
                    onChange={(e) => setMaxp(e.target.value)}
                  />
                </div>
              </div>

              <button className="btn btn-outline-dark w-100 mt-2" onClick={saveSettings}>
                설정 저장
              </button>

              <div className="mt-2" dangerouslySetInnerHTML={{ __html: msgHtml }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerWaitingManage;